import { render, staticRenderFns } from "./AboutMyColorBase.vue?vue&type=template&id=0de8817a&scoped=true&"
import script from "./AboutMyColorBase.vue?vue&type=script&lang=ts&"
export * from "./AboutMyColorBase.vue?vue&type=script&lang=ts&"
import style0 from "./AboutMyColorBase.vue?vue&type=style&index=0&id=0de8817a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de8817a",
  null
  
)

export default component.exports